export default __webpack_public_path__ + "static/apo-blob-4698fdc4f18946e08ad5a63fe2330231.png";